import axios from "axios";
import TokenService from "../utils/TokenService";

const refreshTokenApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_AUTH_HOST}/api/v1`,
    withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});

let isRunning = false;
class RefreshToken {
    wait() {
        return new Promise((resolve) => {
            setTimeout(resolve, 1000);
        });
    }

    async getAccessToken() {
        if (isRunning) {
            while (isRunning) {
                await this.wait();
                if (!isRunning) {
                    return;
                }
            }
        }
        isRunning = true;
        await this.getNewToken();
        isRunning = false;
    }

    async getNewToken() {
        await refreshTokenApi.get("auth/refresh")
            .then(data => {
                TokenService.setAccessToken(data.data.userAccessToken);
                TokenService.setRefreshToken(data.data.userRefreshToken);
            })
            .catch(error => {
                window.location.href = process.env.REACT_APP_ID_SITE + "/logout";
//                throw error;
            })
            .finally(() => {
            });
    }
}
export default new RefreshToken();
